export default "__VITE_ASSET__CJT0sRIO__"